import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Button from "../../../../../../core/et3-button";
import { USER_STATUS_ENTRIES } from "../../../../../../constants/picker-entries-constants";
import { isDefinedString, reduce } from "et3-type-guards";
import Et3Picker from "../../../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../../../TypesNEW";

const UserChangeUserStatus = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const userId = getUserAdvancedStore().currentUserId.get();
  const status = reduce(
    () => getUserAdvancedStore().userData.get(userId).status,
    ""
  );
  const value = isDefinedString(
    getUserAdvancedStore().changeStatusInput.get().value
  )
    ? getUserAdvancedStore().changeStatusInput.get()
    : {
        label: status,
        value: ""
      };
  const isChangeStatusEnabled =
    getUserAdvancedStore().isChangeStatusEnabled.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={300}
      height={260}
      fDirection="column"
      alignItems="center"
      justifyContent="space-between"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="center"
        alignItems="flex-start"
        withShadow={false}
        width={300}
        height={45}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label=""
          options={USER_STATUS_ENTRIES}
          onChoose={(value: TEt3PickerSingleValue) => {
            getUserAdvancedStore().changeStatusInput.set(value);
          }}
          value={value}
          style={{
            justifyContent: "flex-start"
          }}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Button
        isEnabled={isChangeStatusEnabled}
        onClick={async () =>
          await getUserAdvancedStore().changeStatus({
            userId
          })
        }
        size="MEDIUM"
        text="CHANGE_STATUS"
        type="GET"
      />
    </ET3Div>
  );
});
export default UserChangeUserStatus;
